
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Tab1Page'
})
